// Domain types for the Admin Roles MSPA.

// A row in the roles list table.
export interface Role {
  id: string;
  name: string;
  default?: boolean;
}

export type PrivilegeScope = "projects" | "settings" | "reports";

// A single privilege definition from GET /v2/privileges.
export interface PrivilegeDefinition {
  id: string; // e.g. "projects.overview"
  scope: PrivilegeScope; // derived from the id prefix
  name: string; // curated label, e.g. "Project Overview"
  description: string;
  levels: string[]; // valid access levels for this privilege
  defaultLevel: string; // the "user" preset level (seed for New)
}

// Controlled values for the role create/edit form. `privileges` maps a
// privilege id to its selected access level ("" = unset).
export interface RoleFormValues {
  name: string;
  default: boolean;
  privileges: Record<string, string>;
}

export const emptyRoleForm: RoleFormValues = {
  name: "",
  default: false,
  privileges: {},
};

// Section order and titles for the form.
export const PRIVILEGE_SCOPES: PrivilegeScope[] = [
  "projects",
  "settings",
  "reports",
];

export const SCOPE_TITLES: Record<PrivilegeScope, string> = {
  projects: "Project Permissions",
  settings: "Settings Permissions",
  reports: "Reports Permissions",
};

// Derive the scope from a privilege id's prefix; defaults to "projects".
export const scopeOf = (privilegeId: string): PrivilegeScope => {
  const prefix = privilegeId.split(".")[0] as PrivilegeScope;
  return PRIVILEGE_SCOPES.includes(prefix) ? prefix : "projects";
};
